
<div>
    <f-read-only-field
        v-if   = "readonly"
        class  = "w-100"
        :dense = "true"
        :label = "label"
        :value = "moneyAsString(currency)"
        color  = "pt-0-5 pl-1 ro-background"
    />

    <f-currency-field
        v-if          = "!readonly"
        class         = "money"
        :label        = "label"
        :readonly     = "readonly"
        v-model       = "currency"
        :hide-details = "true"
        @input        = "onInput"
    />
</div>
